import React from 'react';

import { PopoverPlacement } from '@rover/components/src/callouts/Popover/popover.constants';
import { useEnableSchema } from '@rover/components/src/microdata';
import { Box, Image } from '@rover/kibble/core';
import {
  getAvatarBorderRadius,
  getMobileAvatarSize,
} from '@rover/react-lib/src/pages/search/SearchPage/utilities/searchCardTreatment';
import Badge from '@rover/react-lib/src/pages/search/shared/components/SitterBadge';
import { SearchCardTreatment } from '@rover/types/src/SearchCardTreatment';
import type { SitterBadge } from '@rover/types/src/SitterBadge';

import { AVATAR_BADGE_SIZES, SEARCH_RESULT_CARD_Z_INDEX } from '../SearchResultCard.constants';

type Props = {
  imageUrl: string;
  badge?: SitterBadge;
  description: string;
  cardTreatment: SearchCardTreatment;
};

export default function MobileAvatar({
  imageUrl,
  badge,
  description,
  cardTreatment,
}: Props): React.ReactElement {
  const enableSchema = useEnableSchema();

  const avatarSize = getMobileAvatarSize(cardTreatment);
  const borderRadius = getAvatarBorderRadius(cardTreatment);
  const avatarBadgeSize = AVATAR_BADGE_SIZES.REDUCED;

  return (
    <Box position="relative" width={avatarSize} height={avatarSize}>
      <Image
        src={imageUrl}
        description={description}
        height="100%"
        width="100%"
        borderRadius={borderRadius}
      />
      {badge && (
        <Box
          position="absolute"
          bottom="0"
          right="0"
          width={avatarBadgeSize}
          height={avatarBadgeSize}
          zIndex={`${SEARCH_RESULT_CARD_Z_INDEX.INTERACTIVE}`}
        >
          <Badge
            title={badge.title}
            content={badge.content}
            imageUrl={badge.imageUrl}
            key={badge.imageUrl}
            slug={badge.slug}
            width={avatarBadgeSize}
            popoverPlacement={PopoverPlacement.RIGHT}
            {...(enableSchema ? { itemProp: 'hasCredential' } : {})}
          />
        </Box>
      )}
    </Box>
  );
}
